// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.input-container[data-v-4278f12b]{\r\n\tdisplay:inline-block;\r\n\twidth: 100px;\n}\n.control-padding[data-v-4278f12b]{\r\n\tpadding:5px;\n}\n.full-height[data-v-4278f12b]{\r\n\theight: 100vh;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
